<template>
  <div class="h-topo-treebox">
    <div class="h-topo-treesearch" :class=' {  "h-borderBox-top": hasBorder} ' v-if="searchBox_.show" >
      <ejs-textbox ref='baseSearch' :title='searchTreeString' :placeholder="SearchHoder" v-model="searchTreeString" @keydown.native.enter='change'></ejs-textbox>
    </div>
    <div class="h-topo-tree">
      <ejs-treeview id='baseTree' ref='baseTree' :enablePersistence='true' :fields='fields' :nodeClicked='nodeClicked' :showCheckBox="checkBox_.show" :nodeChecked='checkedNodesFunc'></ejs-treeview>
    </div>
  </div>
</template>
<script>

let treeDatas = [{ children: [] }];
let responseData = [];
let resTemp = [];
export default {
  name: 'topo-tree',
  components: {},
  props: {
    message: [String, Number],
    searchBox: {
      type: Object,
      default() {
        return {
          show: true
        };
      }
    },
    checkBox: {
      type: Object,
      default() {
        return {
          show: false
        };
      }
    },
    hasBorder: { type: Boolean, default: false },
    graphType: '',
  },
  data() {
    return {
      SearchHoder: this.$t('Topo.nodeName'),
      fields: {
        dataSource: treeDatas,
        id: 'id',
        text: 'name',
        child: 'children',
        iconCss:'icon',
        isChecked: 'isChecked',
        selected: 'selected',
        tooltip: 'name',
      },
      searchBox_: this.searchBox,
      checkBox_: this.checkBox,
      neIdListCache: {},
      nodeClicked: (args) => {
        const node = responseData[responseData.findIndex(v => v.id === args.node.dataset.uid)];
        this.sendMessage(node.id);
      },
      searchTreeString: ''
    };
  },
  watch: {
    //拓扑图定位到树，将树节点选中
    message() {
       console.log('massage11111111111111111111111111', this.message);
      for (let i = 0; i < responseData.length; i++) {
        responseData[i].selected = 'false';
        if (responseData[i].id === this.message.toString()) {
          responseData[i].selected = 'true';
        }
      }
       const data = this.transfer2TreeData(responseData);
          this.fields = {
            dataSource: data,
            id: 'id',
            text: 'name',
            iconCss:'icon',
            child: 'children',
            isChecked: 'isChecked',
            selected: 'selected',
            tooltip: 'name',
            expanded: 'name',
          };
    }
  },
  methods: {
    //  由于ej2的tree要指定节点是否具有子节点，所以需要将节点转换为Tree结构
    transfer2TreeData(treeData, parentId = 'null') {
      const aaaa = treeData.filter(item => parentId.indexOf(item.parentId) > -1);
      return aaaa.map(item => {
          const { id, name, icon, selected } = item;
          return {
            isChecked: this.neIdListCache[id],
            id,
            name,
            icon,
            selected,
            children: this.transfer2TreeData(treeData, new Array(`${item.id}`))
          };
        });
    },

    // 根据网元的在线状态拼样式
    getTreeDataStyle(){
      responseData = [];
      for (let i = 0; i < resTemp.length; i++) {
        if( Number(resTemp[i].typeCode) == 30002)
          resTemp[i].onlineStatus = 1;
        if( resTemp[i].parentId == null)
          resTemp[i].onlineStatus = 1;

        const iconStyle = resTemp[i].onlineStatus ===1?
        'icon hero-icon'+' '+`${resTemp[i].icon}`+' '+'h-pm-iconOnline':
        'icon hero-icon'+' '+`${resTemp[i].icon}`+' '+'h-pm-iconOffline';
        responseData.push({
          ...resTemp[i],
           icon:iconStyle,
           id:`${resTemp[i].id}`,
           parentId:`${resTemp[i].parentId}`
        })

        if( resTemp[i].typeCode == '0'){
          responseData[i].icon = resTemp[i].onlineStatus === 1?
          'icon hero-icon hero-icon-topo-subnet h-pm-iconOnline'
          : 'icon hero-icon hero-icon-topo-subnet  h-pm-iconOffline';
        }
      }
      return responseData;
    },
    // 查TOPO树数据
    getTopoTreeData() {
      const isLogical = this.graphType;
      let url = '/lte/ems/topo/logicalView';
      if (isLogical=='1') {
        url = '/lte/ems/topo/logicalView';
      }else if(isLogical=='0'){
        url = '/lte/ems/topo/physicalView';
      }else if(isLogical=='2'){
        url = '/lte/ems/topo/logicalPhysicalView';//显示逻辑视图+物理视图，但不包含5GC环境
      }
      const This = this;
      This.$axios.get(url).then(response => {
        if(response.data === undefined){
          return;
        }
        if(response.status === 200){
          if (response.data.errorCode === 'SUCCESS') {
            resTemp = response.data.resultVal;
            console.log("resTemp",resTemp);
            responseData = This.getTreeDataStyle();
            treeDatas = This.transfer2TreeData(responseData);

            This.fields = {
              dataSource: treeDatas,
              id: 'id',
              text: 'name',
              child: 'children',
              iconCss:'icon',
              isChecked: 'isChecked',
              // selected: 'selected',
              tooltip: 'name',
              expanded: 'name',
            };
          }
        }
      });

    },
    // 网元树模糊搜索
    change() {
      const This = this;
      if (this.searchTreeString !== '') {
        const selectData = responseData
          .filter(item => item.name.indexOf(this.searchTreeString) > -1)
          .map(item => {
            const { id, name,icon } = item;
            return {
              id,
              name,
              icon,
              isChecked: !!this.neIdListCache[id],
              children: {}
              };
            });
          if (selectData.length !== 0) {
            This.fields = {
              dataSource: selectData,
            };
          } else {
            This.fields = {
              dataSource: null,
            };
          }
        } else {
          This.fields = {
            dataSource: this.transfer2TreeData(responseData),
          };
        }


    },
    // 给拓扑图传网元ID
    sendMessage(args) {
      this.$emit('sendInfo', args);
    },
    /* 监听check操作，将选中节点id加入缓存
     * author: h26635
     */
    checkedNodesFunc(args) {
      if (args.isInteracted) {
        if (args.action === 'check') {
          this.neIdListCache[args.data[0].id] = true;
        } else if (args.action === 'uncheck') {
          this.neIdListCache[args.data[0].id] = false;
        }
      }
    },
    /* 取消所有选中的节点
     * author: h26635
     */
    uncheckAll() {
      const serachObj = this.$refs.baseSearch;
      if (serachObj) {
        serachObj.value = '';
      }
      const treeObj = this.$refs.baseTree.ej2Instances;
      treeObj.uncheckAll();
      this.neIdListCache = {};
      this.change('');
    },
    /*
     * 根据节点实际选中情况，刷新页面选中效果
     */
    refreshCheckStatus() {
      responseData = this.getTreeDataStyle();
      treeDatas = this.transfer2TreeData(responseData);
      this.fields = {
        dataSource: treeDatas,
        id: 'id',
        text: 'name',
        child: 'children',
        iconCss:'icon',
        isChecked: 'isChecked',
        tooltip: 'name',
        expanded: 'name',
      };
    },

    /* 获取当前显示树选中节点数组
     * author: h26635
     */
    getNodeList() {
      const treeObj = this.$refs.baseTree.ej2Instances;
      const checkIdList = treeObj.getAllCheckedNodes();

      const nodeList = [];
      for (let i = 0; i < checkIdList.length; i++) {
        const node = responseData[responseData.findIndex(v => v.id === checkIdList[i])];
        nodeList.push(node);
      }
      return nodeList;
    },
    //过滤子网，只保留基站节点
    getNodeListWithoutSubnet() {
      const treeObj = this.$refs.baseTree.ej2Instances;
      const checkIdList = treeObj.getAllCheckedNodes();
      const filterCheckIdList = checkIdList.filter(item => {
        const matchedObject = resTemp.find(obj => obj.id == item)
        return matchedObject.typeCode != "0"
      })

      const nodeList = [];
      for (let i = 0; i < filterCheckIdList.length; i++) {
        const node = responseData[responseData.findIndex(v => v.id === filterCheckIdList[i])];
        nodeList.push(node);
      }
      return nodeList;
    },
    /* 获取所有缓存中选中节点数组
     * author: h26635
     */
    getCacheNodeList() {
      const checkIdList = [];
      // for (const i in this.neIdListCache) {
      //   if (this.neIdListCache[i] === true) {
      //     checkIdList.push(i);
      //   }
      // }
      Object.entries(this.neIdListCache).forEach((value) => {
        if (value[1] === true) {
          checkIdList.push(value[0]);
        }
      });
      const nodeList = [];
      for (let i = 0; i < checkIdList.length; i++) {
        const node = responseData[responseData.findIndex(v => v.id === checkIdList[i])];
        nodeList.push(node);
      }
      return nodeList;
    },
    /* 获取网元树搜索框关键词
     * author: h26635
     */
    getSearchValue() {
      return this.$refs.baseSearch.value;
    },

 //   webSocket更新在线状态, id:网元id, onStatus:状态 1:在线 0:不在线
    setOnlineStatus(id, onlineStatus) {
      console.log('拓扑树状态', id, onlineStatus);
      const changeOnlineStatus = parseInt(onlineStatus);
    //单个处理网元在线状态
      if(typeof id === 'number'){
        const index = resTemp.findIndex(v => v.id === id);
        if (index > -1) {
          // if(resTemp[index].onlineStatus !== changeOnlineStatus){
            if( resTemp[index].typeCode === 0){
            resTemp[index].icon = 'hero-icon-topo-subet';
            }
            let selectLi = document.querySelector('[data-uid='+'"'+`${id}`+'"'+']');
            if(changeOnlineStatus === 1){
              var aBox=this.getByClass(selectLi, 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOffline');
              if(aBox.length>0){
               aBox[0].setAttribute("class", 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOnline');
              }
            }
            if(changeOnlineStatus === 0){
              var aBox=this.getByClass(selectLi, 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOnline');
              if(aBox.length>0){
              aBox[0].setAttribute("class", 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOffline');
              }
            }
    //    }
        }
      }
    //批量处理网元在线状态
      if(typeof id === 'object'){
        for (let i = 0; i < id.length; i++) {
        const index = resTemp.findIndex(v => v.id === id[i]);
        if (index > -1) {
          // if(resTemp[index].onlineStatus !== changeOnlineStatus){
            if( resTemp[index].typeCode === 0){
            resTemp[index].icon = 'hero-icon-topo-subet';
            }
            let selectLi = document.querySelector('[data-uid='+'"'+`${id[i]}`+'"'+']');
            if(changeOnlineStatus === 1){
              var aBox=this.getByClass(selectLi, 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOffline');
              if(aBox.length>0){
               aBox[0].setAttribute("class", 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOnline');
              }
            }
            if(changeOnlineStatus === 0){
              var aBox=this.getByClass(selectLi, 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOnline');
              if(aBox.length>0){
              aBox[0].setAttribute("class", 'e-list-icon icon hero-icon' +' '+ `${resTemp[index].icon}`+' '+'h-pm-iconOffline');
              }
            }
          // }
          }
         }
        }
      } ,

    getByClass(oParent, sClass){
    var aResult=[];
    var aEle=oParent.getElementsByTagName('*');
    for(var i=0;i<aEle.length;i++){
        if(aEle[i].className==sClass)
        {
            aResult.push(aEle[i]);
        }
    }
    return aResult;
  }
},
  mounted() {
    this.getTopoTreeData();
  }
};
</script>
